var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08624 0.963524C7.23592 0.502868 7.88762 0.50287 8.0373 0.963525L9.24562 4.68237C9.31256 4.88838 9.50454 5.02786 9.72115 5.02786H13.6314C14.1157 5.02786 14.3171 5.64767 13.9253 5.93237L10.7618 8.23075C10.5866 8.35807 10.5133 8.58375 10.5802 8.78976L11.7885 12.5086C11.9382 12.9693 11.411 13.3523 11.0191 13.0676L7.85566 10.7693C7.68042 10.6419 7.44312 10.6419 7.26787 10.7693L4.10443 13.0676C3.71258 13.3523 3.18534 12.9693 3.33501 12.5086L4.54334 8.78976C4.61028 8.58375 4.53695 8.35807 4.3617 8.23075L1.19826 5.93237C0.806406 5.64767 1.0078 5.02786 1.49216 5.02786H5.40238C5.619 5.02786 5.81098 4.88838 5.87791 4.68237L7.08624 0.963524Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4dbf1be354723fb022a581df7e5db7fe.svg";
export { ForwardRef as ReactComponent };